import { DefineComponent, FunctionalComponent } from "vue";

const loading: FunctionalComponent = function vLoading(_props, context)
{
    return (
        <div class="loadingContainer" {...context.attrs} >
            <img class="loadingImage" src={`${window.skyward.global.virtualDir}content/loading.gif`} />
        </div>
    );
}
export default loading as unknown as DefineComponent<{}, JSX.Element>;